import {
  Theme as GraphTheme,
  PageBlockUnion,
  ProcedureTypes,
  SubPages,
} from '@/components/common/Providers/GraphqlProvider/generated';

import { TailwindColors } from '../../tailwind.config';

export const COLORS = { ...TailwindColors };

export type TPageBlockUnionTypename =
  | 'PageInstitutionalProgramsBlock' // this types does not appear to be useful, candidate for deletion
  | 'PageDynamicsHeaderBlock' // this types does not appear to be useful, candidate for deletion
  | 'PageTransparencyAccordionBlock' // this types does not appear to be useful, candidate for deletion
  | NonNullable<PageBlockUnion['__typename']>;

//TODO: This has better typesafety than the other options. and use the same type name for key as value.
//The goal is to transition to this constant instead of TypeNameBlocks and DYNAMIC_TYPES_BLOCKS
export const TypeNamePageBlocks = {
  PageInstitutionalProgramsBlock: 'PageInstitutionalProgramsBlock',
  PageDynamicsHeaderBlock: 'PageDynamicsHeaderBlock',
  PageTransparencyAccordionBlock: 'PageTransparencyAccordionBlock',
  PageAccessibilityBar: 'PageAccessibilityBar',
  PageAccessibilityButton: 'PageAccessibilityButton',
  PageAccordionBlock: 'PageAccordionBlock',
  PageAlertsBlock: 'PageAlertsBlock',
  PageAttentionLinesBlock: 'PageAttentionLinesBlock',
  PageAuthenticationBar: 'PageAuthenticationBar',
  PageCabinetBlock: 'PageCabinetBlock',
  PageCorporateLogosBlock: 'PageCorporateLogosBlock',
  PageCustomBlock: 'PageCustomBlock',
  PageEventsBlock: 'PageEventsBlock',
  PageEventSliderBlock: 'PageEventSliderBlock',
  PageFooterBar: 'PageFooterBar',
  PageHeaderBar: 'PageHeaderBar',
  PageHeaderOrganizationBar: 'PageHeaderOrganizationBar',
  PageInstitutionalProgramsSliderBlock: 'PageInstitutionalProgramsSliderBlock',
  PageInstitutionalProgramsTypesBlock: 'PageInstitutionalProgramsTypesBlock',
  PageMapBlock: 'PageMapBlock',
  PageNavigationBar: 'PageNavigationBar',
  PageNewsletterBlock: 'PageNewsletterBlock',
  PageParticipateDownloadBlock: 'PageParticipateDownloadBlock',
  PageParticipateElementBlock: 'PageParticipateElementBlock',
  PageParticipateHeaderBlock: 'PageParticipateHeaderBlock',
  PagePqrsdfActionBlock: 'PagePqrsdfActionBlock',
  PagePqrsdfConsultBlock: 'PagePqrsdfConsultBlock',
  PagePressroomBlock: 'PagePressroomBlock',
  PageProcedureFeedbackBlock: 'PageProcedureFeedbackBlock',
  PageProcedureHeaderBlock: 'PageProcedureHeaderBlock',
  PageProcedureMainBlock: 'PageProcedureMainBlock',
  PageProceduresBlock: 'PageProceduresBlock',
  PageQuickAccessBar: 'PageQuickAccessBar',
  PageRegulationsBlock: 'PageRegulationsBlock',
  PageSearchBlock: 'PageSearchBlock',
  PageSliderBlock: 'PageSliderBlock',
  PageSnsBlock: 'PageSnsBlock',
  PageSocialNetworksBlock: 'PageSocialNetworksBlock',
  PageStyledTableBlock: 'PageStyledTableBlock',
  PageSubDownloadBlock: 'PageSubDownloadBlock',
  PageSubHeaderBlock: 'PageSubHeaderBlock',
  PageTaxesBlock: 'PageTaxesBlock',
  PageTransparencyBlock: 'PageTransparencyBlock',
  PageTransparencyHeaderBlock: 'PageTransparencyHeaderBlock',
} as const satisfies Record<TPageBlockUnionTypename, string>;

type SubsetOf<T extends TPageBlockUnionTypename> = T;

export type TTransparencyBlockUnionTypename = SubsetOf<
  | typeof TypeNamePageBlocks.PageSubHeaderBlock
  | typeof TypeNamePageBlocks.PageTransparencyBlock
  | typeof TypeNamePageBlocks.PageTransparencyAccordionBlock
  | typeof TypeNamePageBlocks.PageAccordionBlock
  | typeof TypeNamePageBlocks.PageCustomBlock
>;

export type TParticipateBlockUnionTypename = SubsetOf<
  | typeof TypeNamePageBlocks.PageSubHeaderBlock
  | typeof TypeNamePageBlocks.PageParticipateElementBlock
  | typeof TypeNamePageBlocks.PageParticipateDownloadBlock
  | typeof TypeNamePageBlocks.PageCustomBlock
  | typeof TypeNamePageBlocks.PageAccordionBlock
  | typeof TypeNamePageBlocks.PageQuickAccessBar
  | typeof TypeNamePageBlocks.PageAlertsBlock
>;

export type TPressroomBlockUnionTypename = SubsetOf<
  | typeof TypeNamePageBlocks.PagePressroomBlock
  | typeof TypeNamePageBlocks.PageSnsBlock
  | typeof TypeNamePageBlocks.PageNewsletterBlock
>;

export type TCustomBlockUnionTypename = 'PageCustomBlock' | 'PageSubHeaderBlock';

export const TypeNameBlocks = {
  PAGE_EVENTS_SLIDER: 'PageEventSliderBlock',
  PAGE_ACCORDION_REGULATIONS: 'PageRegulationsAccordionBlock',
  PAGE_CORPORATE_LOGOS: 'PageCorporateLogosBlock',
  PAGE_HEADER_BAR: 'PageHeaderBar',
  PAGE_AUTHENTICATION_BAR: 'PageAuthenticationBar',
  PAGE_NAVIGATION_BAR: 'PageNavigationBar',
  PAGE_ACCESSIBILITY_BAR: 'PageAccessibilityBar',
  PAGE_FOOTER_BAR: 'PageFooterBar',
  PAGE_TAXES_BLOCK: 'PageTaxesBlock',
  PAGE_SLIDER_BLOCK: 'PageSliderBlock',
  PAGE_NEWSLETTER_BLOCK: 'PageNewsletterBlock',
  PAGE_PROCEDURES_BLOCK: 'PageProceduresBlock',
  PAGE_REGULATIONS_BLOCK: 'PageRegulationsBlock',
  PAGE_REGULATIONS_HEADER_BLOCK: 'PageRegulationsHeaderBlock',
  PAGE_INSTITUTIONAL_PROGRAMS_BLOCK: 'PageInstitutionalProgramsBlock',
  PAGE_INSTITUTIONAL_PROGRAMS_HEADER_BLOCK: 'PageInstitutionalProgramsHeaderBlock',
  PAGE_CABINET_BLOCK: 'PageCabinetBlock',
  PAGE_SOCIAL_NETWORKS_BLOCK: 'PageSocialNetworksBlock',
  PAGE_SNS_BLOCK: 'PageSnsBlock',
  PAGE_EVENTS_BLOCK: 'PageEventsBlock',
  PAGE_QUICK_ACCESS_BAR: 'PageQuickAccessBar',
  PAGE_ATTENTION_LINES_BLOCK: 'PageAttentionLinesBlock',
  PAGE_TRANSPARENCY_BLOCK: 'PageTransparencyBlock',
  PAGE_TRANSPARENCY_HEADER_BLOCK: 'PageTransparencyHeaderBlock',
  PAGE_TRANSPARENCY_ACCORDION_BLOCK: 'PageTransparencyAccordionBlock',
  PAGE_PRESS_ROOM_BLOCK: 'PagePressroomBlock',
  PAGE_PARTICIPATES_HEADER_BLOCK: 'PageParticipateHeaderBlock',
  PAGE_PARTICIPATES_ELEMENT_BLOCK: 'PageParticipateElementBlock',
  PAGE_PARTICIPATES_DOWNLOAD_BLOCK: 'PageParticipateDownloadBlock',
  PAGE_PROCEDURES_HEADER_BLOCK: 'PageProcedureHeaderBlock',
  PAGE_PROCEDURES_CARD_BLOCK: 'PageProcedureMainBlock',
  PAGE_PROCEDURES_AREA_BLOCK: 'PageProcedureFeedbackBlock',
  PAGE_HEADER_ORGANIZATION_BLOCK: 'PageHeaderOrganizationBar',
  PAGE_INSTITUTIONAL_PROGRAM_CAROUSEL: 'PageInstitutionalProgramsSliderBlock',
  PAGE_INSTITUTIONAL_PROGRAM_BLOCK: 'PageInstitutionalProgramsTypesBlock',
  PAGE_SUBHEADER_BLOCK: 'PageSubHeaderBlock',
  PAGE_PQRSD_ACTION_BLOCK: 'PagePqrsdfActionBlock',
  PAGE_PQRSD_CONSULT_BLOCK: 'PagePqrsdfConsultBlock',
  PAGE_PQRSD_HEADER_BLOCK: 'PagePqrsdHeaderBlock',
  PAGE_DYNAMICS_HEADER_BLOCK: 'PageDynamicsHeaderBlock',
  PAGE_DOWNLOAD_REGULATIONS_BLOCK: 'PageSubDownloadBlock',
  PAGE_CUSTOM_BLOCK: 'PageCustomBlock',
  PAGE_ACCORDION_BLOCK: 'PageAccordionBlock',
  PAGE_STYLED_TABLE_BLOCK: 'PageStyledTableBlock',
  PAGE_ALERTS_BLOCK: 'PageAlertsBlock',
  PAGE_ACCESSIBILITY_BUTTON: 'PageAccessibilityButton',
  PAGE_SEARCH_BLOCK: 'PageSearchBlock',
  PAGE_MAP_BLOCK: 'PageMapBlock',
} as const;

export const PageBlockConst = {
  PageAccessibilityBar: 'accessibilityBar',
  PageAttentionLinesBlock: 'attentionLinesBlock',
  PageAuthenticationBar: 'authenticationBar',
  PageCabinetBlock: 'cabinetBlock',
  PageEventsBlock: 'eventsBlock',
  PageFooterBar: 'footerBar',
  PageHeaderBar: 'headerBar',
  PageInstitutionalProgramsBlock: 'institutionalProgramsBlock',
  PageSocialNetworksBlock: 'socialNetworksBlock',
  PageQuickAccessBar: 'quickAccessBar',
  PageNavigationBar: 'navigationBar',
  PageNewsletterBlock: 'newsletterBlock',
  PageProceduresBlock: 'proceduresBlock',
  PageRegulationsBlock: 'regulationsBlock',
  PageSliderBlock: 'sliderBlock',
  PageSnsBlock: 'snsBlock',
  PageTaxesBlock: 'taxesBlock',
  PageTransparencyBlock: 'transparencyBlock',
  PageCustomBlock: 'customBlock',
  PageTransparencyHeaderBlock: 'transparencyHeaderBlock',
  PageTransparencyAccordionBlock: 'transparencyAccordionBlock',
  PagePressroomBlock: 'pressroomBlock',
  PageParticipateHeaderBlock: 'participateHeaderBlock',
  PageParticipateElementBlock: 'participateElementBlock',
  PageParticipateDownloadBlock: 'participateDownloadBlock',
  PageProcedureHeaderBlock: 'procedureHeaderBlock',
  PageProcedureMainBlock: 'procedureMainBlock',
  PageProcedureFeedbackBlock: 'procedureFeedbackBlock',
  PageInstitutionalProgramsSliderBlock: 'institutionalProgramsSliderBlock',
  PageInstitutionalProgramsTypesBlock: 'institutionalProgramsTypesBlock',
  PageStyledTableBlock: 'styledTableBlock',
  PageSubHeaderBlock: 'subHeaderBlock',
  PageAccordionBlock: 'accordionBlock',
  PageSubDownloadBlock: 'subDownloadBlock',
  PageMapBlock: 'mapBlock',
  PageAlertsBlock: 'alertsBlock',
};

export type PageBlockConstType = typeof PageBlockConst;

export const ROUTE_ADMIN = '/admin';
export const ROUTE_ADMIN_HOME = `${ROUTE_ADMIN}/home`;
export const ROUTE_ADMIN_MANAGE_ACCOUNT = `${ROUTE_ADMIN_HOME}/manage-account`;

export const ROUTE_ADMIN_MICRO_SITES = `${ROUTE_ADMIN_HOME}/micro-sites`;
export const ROUTE_ADMIN_PAGE_CONFIG = `${ROUTE_ADMIN_HOME}/page-config`;
export const ROUTE_ADMIN_HEADER_OBJECTS = `${ROUTE_ADMIN_PAGE_CONFIG}/header-objects`;
export const ROUTE_ADMIN_HEADER_OBJECTS_ITEM = `${ROUTE_ADMIN_HEADER_OBJECTS}/[typeName]/[id]`;
export const ROUTE_ADMIN_FOOTER_OBJECTS = `${ROUTE_ADMIN_PAGE_CONFIG}/footer-objects`;
export const ROUTE_ADMIN_FOOTER_OBJECTS_ITEM = `${ROUTE_ADMIN_FOOTER_OBJECTS}/[typeName]/[id]`;
export const ROUTE_ADMIN_FOOTER_GOV_CO = `${ROUTE_ADMIN_FOOTER_OBJECTS}/footer-gov-co`;
export const ROUTE_ADMIN_HOME_PAGE = `${ROUTE_ADMIN_PAGE_CONFIG}/home-page`;
export const ROUTE_ADMIN_HOME_FOOTER_OBJECT = `${ROUTE_ADMIN_PAGE_CONFIG}/footer-objects`;
export const ROUTE_ADMIN_HOME_PAGE_ITEM = `${ROUTE_ADMIN_HOME_PAGE}/[typeName]/[id]`;

//Page Config micro-sitios
export const ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE = `${ROUTE_ADMIN_MICRO_SITES}/default-sites`;
export const ROUTE_ADMIN_MICRO_SITES_CUSTOM_PAGE = `${ROUTE_ADMIN_MICRO_SITES}/custom-sites`;
export const ROUTE_ADMIN_MICRO_SITES_DYNAMIC_PAGE = `${ROUTE_ADMIN_MICRO_SITES}/dynamic-page`;
export const ROUTE_ADMIN_MICRO_SITES_CUSTOM_PAGE_NEW = `${ROUTE_ADMIN_MICRO_SITES_CUSTOM_PAGE}/new`;
export const ROUTE_ADMIN_MICRO_SITES_CUSTOM_PAGE_EDIT = `${ROUTE_ADMIN_MICRO_SITES_CUSTOM_PAGE}/edit`;
export const ROUTE_ADMIN_MICRO_SITES_DYNAMIC_PAGE_NEW = `${ROUTE_ADMIN_MICRO_SITES_DYNAMIC_PAGE}/new`;
export const ROUTE_ADMIN_MICRO_SITES_DYNAMIC_PAGE_EDIT = `${ROUTE_ADMIN_MICRO_SITES_DYNAMIC_PAGE}/edit`;
export const ROUTE_ADMIN_MICRO_SITES_PAGE = `${ROUTE_ADMIN_PAGE_CONFIG}/micro-site`;
export const ROUTE_ADMIN_MICRO_SITES_PAGE_EDIT = `${ROUTE_ADMIN_MICRO_SITES_PAGE}/edit`;
//templates
export const ROUTE_ADMIN_TEMPLATES = `${ROUTE_ADMIN_MICRO_SITES}/templates`;
export const ROUTE_ADMIN_TEMPLATES_EDIT = `${ROUTE_ADMIN_TEMPLATES}/edit`;
export const ROUTE_ADMIN_TEMPLATES_FOLDER = `${ROUTE_ADMIN_TEMPLATES}/folder`;

export const ROUTE_ADMIN_TRANSPARENCY_PAGE = `${ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE}/transparency-page`; //✅ New system route
export const ROUTE_ADMIN_TRANSPARENCY_PAGE_ITEM = `${ROUTE_ADMIN_TRANSPARENCY_PAGE}/[id]`; //✅ New system route
export const ROUTE_ADMIN_TRANSPARENCY_PAGE_NEW_ITEM_TRANSPARENCY_ACCORDION = `${ROUTE_ADMIN_TRANSPARENCY_PAGE_ITEM}/new`; //✅ New system route
export const ROUTE_ADMIN_TRANSPARENCY_PAGE_EDIT_ITEM_TRANSPARENCY_ACCORDION = `${ROUTE_ADMIN_TRANSPARENCY_PAGE_ITEM}/edit/[item]`; //✅ New system route

export const ROUTE_ADMIN_NEWS_PAGE = `${ROUTE_ADMIN_FOOTER_OBJECTS}/news-page`;

//NAVIGATION PAGES

export const ROUTE_ADMIN_NAVIGATION_PAGES = `${ROUTE_ADMIN_HOME}/navigation-page`;

//PAGE VERSIONES
export const ROUTE_ADMIN_VERSION_PAGE = `${ROUTE_ADMIN_HOME}/admin-version-page`;
export const ROUTE_ADMIN_VERSION_PAGE_PAGE_VERSION = `${ROUTE_ADMIN_VERSION_PAGE}/version-page`;
//PARAMETRIZATION
export const ROUTE_ADMIN_PARAMETRIZATION = `${ROUTE_ADMIN_HOME}/parametrization`;
export const ROUTE_ADMIN_PARAMETRIZATION_THEMES = `${ROUTE_ADMIN_PARAMETRIZATION}/themes`;
export const ROUTE_ADMIN_PARAMETRIZATION_SECURITY = `${ROUTE_ADMIN_PARAMETRIZATION}/security`;
export const ROUTE_ADMIN_PARAMETRIZATION_DEPENDENCIES = `${ROUTE_ADMIN_PARAMETRIZATION}/dependencies`;
export const ROUTE_ADMIN_PARAMETRIZATION_DEPENDENCIES_NEW = `${ROUTE_ADMIN_PARAMETRIZATION_DEPENDENCIES}/new`;
export const ROUTE_ADMIN_PARAMETRIZATION_DEPENDENCIES_EDIT = `${ROUTE_ADMIN_PARAMETRIZATION_DEPENDENCIES}/edit`;
export const ROUTE_ADMIN_PARAMETRIZATION_POSITIONS = `${ROUTE_ADMIN_PARAMETRIZATION}/positions`;
export const ROUTE_ADMIN_PARAMETRIZATION_MICRO_SITES = `${ROUTE_ADMIN_PARAMETRIZATION}/micro-sites`;
export const ROUTE_ADMIN_PARAMETRIZATION_MICRO_SITES_NEW = `${ROUTE_ADMIN_PARAMETRIZATION_MICRO_SITES}/new`;
export const ROUTE_ADMIN_PARAMETRIZATION_MICRO_SITES_EDIT = `${ROUTE_ADMIN_PARAMETRIZATION_MICRO_SITES}/edit`;

// DYNAMICS LIST
export const ROUTE_ADMIN_PARAMETRIZATION_DYNAMIC_LIST = `${ROUTE_ADMIN_PARAMETRIZATION}/dynamic-list`;
export const ROUTE_ADMIN_PARAMETRIZATION_DOCUMENT_TYPES = `${ROUTE_ADMIN_PARAMETRIZATION_DYNAMIC_LIST}/document-types`;
export const ROUTE_ADMIN_PARAMETRIZATION_NEW_DOCUMENT_TYPE = `${ROUTE_ADMIN_PARAMETRIZATION_DOCUMENT_TYPES}/new`;
export const ROUTE_ADMIN_PARAMETRIZATION_EDIT_DOCUMENT_TYPE = `${ROUTE_ADMIN_PARAMETRIZATION_DOCUMENT_TYPES}/edit`;
export const ROUTE_ADMIN_PARAMETRIZATION_NEWS_GROUPS = `${ROUTE_ADMIN_PARAMETRIZATION_DYNAMIC_LIST}/news-groups`;
export const ROUTE_ADMIN_PARAMETRIZATION_NEW_NEWS_GROUP = `${ROUTE_ADMIN_PARAMETRIZATION_NEWS_GROUPS}/new`;
export const ROUTE_ADMIN_PARAMETRIZATION_EDIT_NEWS_GROUP = `${ROUTE_ADMIN_PARAMETRIZATION_NEWS_GROUPS}/edit`;
export const ROUTE_ADMIN_PARAMETRIZATION_EVENTS_GROUPS = `${ROUTE_ADMIN_PARAMETRIZATION_DYNAMIC_LIST}/events-groups`;
export const ROUTE_ADMIN_PARAMETRIZATION_NEW_EVENTS_GROUP = `${ROUTE_ADMIN_PARAMETRIZATION_EVENTS_GROUPS}/new`;
export const ROUTE_ADMIN_PARAMETRIZATION_EDIT_EVENTS_GROUP = `${ROUTE_ADMIN_PARAMETRIZATION_EVENTS_GROUPS}/edit`;

//PAGE ROLES

export const ROUTE_ADMIN_PAGE_ACCOUNT_USERS = `${ROUTE_ADMIN_PARAMETRIZATION_SECURITY}/account-users`;

export const ROUTE_ADMIN_PAGE_ACCOUNT_USERS_ADMIN = `${ROUTE_ADMIN_PARAMETRIZATION_SECURITY}/account-users-admin`;

export const ROUTE_ADMIN_PAGE_ROLE_MANAGEMENT = `${ROUTE_ADMIN_PAGE_CONFIG}/role-management`;
export const ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS = `${ROUTE_ADMIN_PARAMETRIZATION_SECURITY}/account-users`;
export const ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_NEW_USER = `${ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS}/new-user`;
export const ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_EDIT_USER = `${ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS}/edit-user/[id]`;
export const ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT = `${ROUTE_ADMIN_PARAMETRIZATION_SECURITY}/role-management`;
export const ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT_NEW_ROLE = `${ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT}/new-role`;
export const ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT_EDIT_ROLE = `${ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT}/edit-role/[id]`;
export const ROUTE_ADMIN_PAGE_SECURITY_SYSTEM_AUDIT = `${ROUTE_ADMIN_PARAMETRIZATION_SECURITY}/system-audit`;

//SYSTEM PARAMETERS
export const ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS = `${ROUTE_ADMIN_PARAMETRIZATION}/parameters`;
export const ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_NEW = `${ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS}/new`;
export const ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_EDIT = `${ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS}/edit/[id]`;

//links of interes
export const ROUTE_ADMIN_HOME_NEW_LINKS_OF_INTEREST = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/new-link-interest`;
export const ROUTE_ADMIN_HOME_EDIT_LINKS_OF_INTEREST = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/edit-link-interest/[item]`;

//Tax access button
export const ROUTE_ADMIN_HOME_PAGE_NEW_TAX_ACCESS_BUTTON = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/new-tax-access-button`;
export const ROUTE_ADMIN_HOME_PAGE_EDIT_TAX_ACCESS_BUTTON = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/edit-tax-access-button/[item]`;

//Navigation Bar
export const ROUTE_ADMIN_HEADER_PAGE_NEW_NAVIGATION_BAR = `${ROUTE_ADMIN_HEADER_OBJECTS_ITEM}/new-navigation-bar/[item]`;
export const ROUTE_ADMIN_HEADER_PAGE_EDIT_NAVIGATION_BAR = `${ROUTE_ADMIN_HEADER_OBJECTS_ITEM}/edit-navigation-bar/[name]/[item]`;
export const ROUTE_ADMIN_HEADER_PAGE_NEW_ITEM_NAVIGATION_BAR = `${ROUTE_ADMIN_HEADER_PAGE_EDIT_NAVIGATION_BAR}/new-item/[subitem]`;
export const ROUTE_ADMIN_HEADER_PAGE_EDIT_ITEM_NAVIGATION_BAR = `${ROUTE_ADMIN_HEADER_PAGE_EDIT_NAVIGATION_BAR}/edit-item/[subname]/[subitem]`;

//social network config page home
//social network config page home
export const ROUTE_ADMIN_HOME_NEW_SLIDER_SOCIAL_NETWORK = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/new-slider-social-network`;
export const ROUTE_ADMIN_HOME_EDIT_SLIDER_SOCIAL_NETWORK = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/edit-slider-social-network/[item]`;
export const ROUTE_ADMIN_HOME_NEW_TAB_SOCIAL_NETWORK = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/new-tab-social-network`;
export const ROUTE_ADMIN_HOME_EDIT_TAB_SOCIAL_NETWORK = `${ROUTE_ADMIN_HOME_PAGE_ITEM}/edit-tab-social-network/[item]`;

// content management
export const ROUTE_ADMIN_CONTENT_MANAGEMENT = `${ROUTE_ADMIN_HOME}/content-management`;

// news
export const ROUTE_ADMIN_PRESS_ROOM = `${ROUTE_ADMIN_HOME}/content-management/news-management`;
export const ROUTE_PRESS_ROOM_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/news-management`;

export const ROUTE_PROCEDURES_SERVICES_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/procedures-and-services`;

export const ROUTE_DOCUMENTS_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/documents`;

// content participate
export const ROUTE_PARTICIPATE_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/participate`;
export const ROUTE_PARTICIPATE_MANAGEMENT_NEW_REGULATION = `${ROUTE_PARTICIPATE_MANAGEMENT}/new-regulation`;
export const ROUTE_PARTICIPATE_MANAGEMENT_EDIT_REGULATION = `${ROUTE_PARTICIPATE_MANAGEMENT}/edit-regulation/[id]`;

// content regulation
export const ROUTE_REGULATION_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/regulation`;
export const ROUTE_REGULATION_MANAGEMENT_NEW = `${ROUTE_REGULATION_MANAGEMENT}/new`;
export const ROUTE_REGULATION_MANAGEMENT_EDIT = `${ROUTE_REGULATION_MANAGEMENT}/edit/[id]`;

// content participate
export const ROUTE_PARTICIPATE_CONTENT_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/participate`;
export const ROUTE_PARTICIPATE_CONTENT_MANAGEMENT_NEW = `${ROUTE_PARTICIPATE_CONTENT_MANAGEMENT}/new`;
export const ROUTE_PARTICIPATE_CONTENT_MANAGEMENT_EDIT = `${ROUTE_PARTICIPATE_CONTENT_MANAGEMENT}/edit/[id]`;

// content event

export const ROUTE_EVENT_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/events`;

export const ROUTE_INSTITUTIONAL_PROGRAMS_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/institutional-programs-management`;

//Press Room Page Config
export const ROUTE_ADMIN_CONFIG_PAGE_ROOM = `${ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE}/press-room`; //✅ New system route

export const ROUTE_ADMIN_CONFIG_PAGE_ROOM_ITEM = `${ROUTE_ADMIN_CONFIG_PAGE_ROOM}/[id]`; //✅ New system route
export const ROUTE_ADMIN_CONFIG_PAGE_ROOM_NEW_SOCIAL_NETWORK = `${ROUTE_ADMIN_CONFIG_PAGE_ROOM_ITEM}/new`; //✅ New system route
export const ROUTE_ADMIN_CONFIG_PAGE_ROOM_EDIT_SOCIAL_NETWORK = `${ROUTE_ADMIN_CONFIG_PAGE_ROOM_ITEM}/edit`; //✅ New system route

//Press Room Page Config
export const ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS = `${ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE}/institutional-programs`;
export const ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_ITEM = `${ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS}/[id]`;
export const ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_NEW_ITEM = `${ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_ITEM}/new`;
export const ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_EDIT_ITEM = `${ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_ITEM}/edit/[item]`;

//Page Services Config
export const ROUTE_ADMIN_SERVICES_PAGE = `${ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE}/services-page`; //✅ New system route
export const ROUTE_ADMIN_SERVICES_PAGE_ITEM = `${ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE}/[id]`; //✅ New system route

//Page participes Config
export const ROUTE_ADMIN_PARTICIPATES_PAGE = `${ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE}/participates-page`;
export const ROUTE_ADMIN_PARTICIPATES_PAGE_ITEM = `${ROUTE_ADMIN_PARTICIPATES_PAGE}/[id]`;
export const ROUTE_ADMIN_PARTICIPATES_PAGE_NEW_ELEMENT = `${ROUTE_ADMIN_PARTICIPATES_PAGE_ITEM}/new`;
export const ROUTE_ADMIN_PARTICIPATES_PAGE_EDIT_ELEMENT = `${ROUTE_ADMIN_PARTICIPATES_PAGE_ITEM}/edit/[item]`;

//Page downloadable

export const ROUTE_ADMIN_CONFIG_PAGE_DOWNLOADABLE = `${ROUTE_ADMIN_PAGE_CONFIG}/downloadable`;

// content participate
export const ROUTE_DYNAMIC_PAGES_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/dynamic-pages`;
export const ROUTE_DYNAMIC_PAGES_MANAGEMENT_NEW = `${ROUTE_DYNAMIC_PAGES_MANAGEMENT}/new-page`;
export const ROUTE_DYNAMIC_PAGES_MANAGEMENT_EDIT = `${ROUTE_DYNAMIC_PAGES_MANAGEMENT}/edit-page/[id]`;

// content PQRSD
export const ROUTE_PQRSD_CONTENT_MANAGEMENT = `${ROUTE_ADMIN_CONTENT_MANAGEMENT}/pqrsd`;
export const ROUTE_PQRSD_CONTENT_MANAGEMENT_NEW = `${ROUTE_PQRSD_CONTENT_MANAGEMENT}/new`;
export const ROUTE_PQRSD_CONTENT_MANAGEMENT_EDIT = `${ROUTE_PQRSD_CONTENT_MANAGEMENT}/edit/[id]`;

// PQRSD managment
export const ROUTE_ADMIN_PQRSD_PAGE = `${ROUTE_ADMIN_HOME}/pqrsd`;
export const ROUTE_ADMIN_PQRSD_PAGE_EDIT = `${ROUTE_ADMIN_PQRSD_PAGE}/[typeName]/[id]`;

// Regulations
export const ROUTE_ADMIN_REGULATIONS_PAGE = `${ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE}/regulations`;

//PUBLIC ROUTES
//PARTICIPATE
export const ROUTE_PARTICIPATE = `/participate`;

//PQRS

export const ROUTE_PQRS = '/pqrs';

export const ROUTE_CHECK_STATUS = 'check-status';

export const THEME_LIST = {
  ElfGreen: GraphTheme.ElfGreen,
  RadicalRed: GraphTheme.RadicalRed,
  GreenDark: GraphTheme.GreenDark,
  Shiraz: GraphTheme.Shiraz,
  BlueDark: GraphTheme.BlueDark,
  Orange: GraphTheme.Orange,
  Marine: GraphTheme.Marine,
  Gold: GraphTheme.Gold,
};

//REGULAR EXPRESIONS
export const NUMBER_CHECK = /^(?=.*[0-9])/;
export const LOWERCASE_CHECK = /^(?=.*[a-z])/;
export const UPPERCASE_CHECK = /^(?=.*[A-Z])/;

export const SYMBOL_CHECK = /[!@#$%*()_+\-=\{\}\[\]\\|;:\/\?]/;
export const REGEX_URL =
  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export const REGEX_NUMBER = /^[0-9]+$/;

const specialCharRegExp = '@$!%*/?&_.;¡¿+-';
export const REGEX_PASSWORD = new RegExp(
  `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[${specialCharRegExp}])[A-Za-z\\d${specialCharRegExp}]{9,16}$`
);

export const ROUTE_LIST_ACTION_URL = [
  { label: 'Normativas', value: SubPages.Regulation },
  { label: 'Inicio', value: SubPages.Home },
  { label: 'Eventos', value: SubPages.Events },
  { label: 'Gabinete', value: SubPages.Cabinet },
  { label: 'Participa', value: SubPages.Participate },
  { label: 'Sala de prensa', value: SubPages.PressRoom },
  { label: 'Trámites', value: SubPages.Procedures },
  { label: 'Transparencia', value: SubPages.Transparency },
  { label: 'PQRSD', value: SubPages.Pqrsdf },
  { label: 'Institucionales', value: SubPages.InstitutionalPrograms },
];

export type navigationPermissionsKeysType = {
  page: string;
  pageBlockFind: string;
  pageBlockCreateDefault: string;
  pageBlockUpdate: string;
  pageBlockPreview: string;
  pageBlockUpdateInactivate: string;
  pageBlockUpdateActive: string;
  pageBlockRemove?: string;
};

export type contentManagementPermissionsKeysType = {
  page: string;
  pageBlockFind: string;
  pageBlockPreview?: string;
  pageBlockCreate: string;
  pageBlockUpdate: string;
  pageBlockRemove: string;
  pageBlockUpdatePublish: string;
  pageBlockUpdateStatusToDraft: string;
  pageBlockUpdateInactivate: string;
};

export const MAIN_GENERAL_URLS = [
  {
    path: ROUTE_ADMIN_HEADER_OBJECTS,
    children: [
      ROUTE_ADMIN_HEADER_OBJECTS,
      ROUTE_ADMIN_HEADER_OBJECTS_ITEM,
      ROUTE_ADMIN_HEADER_PAGE_NEW_NAVIGATION_BAR,
      ROUTE_ADMIN_HEADER_PAGE_EDIT_NAVIGATION_BAR,
      ROUTE_ADMIN_HEADER_PAGE_NEW_ITEM_NAVIGATION_BAR,
      ROUTE_ADMIN_HEADER_PAGE_EDIT_ITEM_NAVIGATION_BAR,
    ],
  },
  {
    path: ROUTE_ADMIN_FOOTER_OBJECTS,
    children: [ROUTE_ADMIN_FOOTER_OBJECTS, ROUTE_ADMIN_FOOTER_OBJECTS_ITEM],
  },
  {
    path: ROUTE_ADMIN_HOME_PAGE,
    children: [
      ROUTE_ADMIN_HOME_PAGE,
      ROUTE_ADMIN_HOME_PAGE_ITEM,
      ROUTE_ADMIN_HOME_PAGE_NEW_TAX_ACCESS_BUTTON,
      ROUTE_ADMIN_HOME_PAGE_EDIT_TAX_ACCESS_BUTTON,
    ],
  },
  {
    path: ROUTE_ADMIN_TRANSPARENCY_PAGE,
    children: [
      ROUTE_ADMIN_TRANSPARENCY_PAGE_ITEM,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_NEW_ITEM_TRANSPARENCY_ACCORDION,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_EDIT_ITEM_TRANSPARENCY_ACCORDION,
    ],
  },
  {
    path: ROUTE_ADMIN_CONFIG_PAGE_ROOM,
    children: [
      ROUTE_ADMIN_CONFIG_PAGE_ROOM_ITEM,
      ROUTE_ADMIN_CONFIG_PAGE_ROOM_NEW_SOCIAL_NETWORK,
      ROUTE_ADMIN_CONFIG_PAGE_ROOM_EDIT_SOCIAL_NETWORK,
    ],
  },
  { path: ROUTE_ADMIN_PARTICIPATES_PAGE, children: [ROUTE_ADMIN_PARTICIPATES_PAGE_ITEM] },
  {
    path: ROUTE_REGULATION_MANAGEMENT,
    children: [ROUTE_REGULATION_MANAGEMENT_NEW, ROUTE_REGULATION_MANAGEMENT_EDIT],
  },
  { path: ROUTE_ADMIN_SERVICES_PAGE, children: [ROUTE_ADMIN_SERVICES_PAGE_ITEM] },
  { path: ROUTE_ADMIN_VERSION_PAGE, children: [ROUTE_ADMIN_VERSION_PAGE_PAGE_VERSION] },
  {
    path: ROUTE_ADMIN_PARAMETRIZATION,
    children: [
      ROUTE_ADMIN_PARAMETRIZATION_THEMES,
      ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS,
      ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_NEW,
      ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_EDIT,
      ROUTE_ADMIN_MANAGE_ACCOUNT,
      ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_EDIT_USER,
      ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_NEW_USER,
      ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS,
      ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT,
      ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT_NEW_ROLE,
      ROUTE_ADMIN_PARAMETRIZATION_DYNAMIC_LIST,
      ROUTE_ADMIN_PARAMETRIZATION_SECURITY,
      ROUTE_ADMIN_PARAMETRIZATION_DEPENDENCIES,
      ROUTE_ADMIN_PARAMETRIZATION_POSITIONS,
    ],
  },
  {
    path: ROUTE_PARTICIPATE_MANAGEMENT,
    children: [
      ROUTE_PARTICIPATE_MANAGEMENT_NEW_REGULATION,
      ROUTE_PARTICIPATE_MANAGEMENT_EDIT_REGULATION,
    ],
  },
  {
    path: ROUTE_DYNAMIC_PAGES_MANAGEMENT,
    children: [ROUTE_DYNAMIC_PAGES_MANAGEMENT_NEW, ROUTE_DYNAMIC_PAGES_MANAGEMENT_EDIT],
  },
  { path: ROUTE_ADMIN_PQRSD_PAGE, children: [ROUTE_ADMIN_PQRSD_PAGE_EDIT] },
  {
    path: ROUTE_PQRSD_CONTENT_MANAGEMENT,
    children: [ROUTE_PQRSD_CONTENT_MANAGEMENT_NEW, ROUTE_PQRSD_CONTENT_MANAGEMENT_EDIT],
  },

  {
    path: ROUTE_ADMIN_MICRO_SITES,
    children: [
      ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE,
      ROUTE_ADMIN_MICRO_SITES_CUSTOM_PAGE,
      ROUTE_ADMIN_MICRO_SITES_DYNAMIC_PAGE,
      ROUTE_ADMIN_TEMPLATES,
    ],
  },
  {
    path: ROUTE_ADMIN_MICRO_SITES_DEFAULT_PAGE,
    children: [
      ROUTE_ADMIN_TRANSPARENCY_PAGE,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_ITEM,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_NEW_ITEM_TRANSPARENCY_ACCORDION,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_EDIT_ITEM_TRANSPARENCY_ACCORDION,

      ROUTE_ADMIN_SERVICES_PAGE,
      ROUTE_ADMIN_SERVICES_PAGE_ITEM,

      ROUTE_ADMIN_PARTICIPATES_PAGE,
      ROUTE_ADMIN_PARTICIPATES_PAGE_ITEM,
      ROUTE_ADMIN_PARTICIPATES_PAGE_NEW_ELEMENT,
      ROUTE_ADMIN_PARTICIPATES_PAGE_EDIT_ELEMENT,

      ROUTE_ADMIN_CONFIG_PAGE_ROOM,
    ],
  },

  {
    path: ROUTE_ADMIN_CONTENT_MANAGEMENT,
    children: [
      ROUTE_DOCUMENTS_MANAGEMENT,
      ROUTE_PRESS_ROOM_MANAGEMENT,
      ROUTE_PARTICIPATE_MANAGEMENT,
      ROUTE_REGULATION_MANAGEMENT,
      ROUTE_PARTICIPATE_CONTENT_MANAGEMENT,
      ROUTE_EVENT_MANAGEMENT,
      ROUTE_INSTITUTIONAL_PROGRAMS_MANAGEMENT,
      ROUTE_PROCEDURES_SERVICES_MANAGEMENT,
      ROUTE_PQRSD_CONTENT_MANAGEMENT,
    ],
  },
];

export const ROUTES_CLIENT = {
  // REGULATIONS: '/regulations',
  REGULATIONS: '/normativas',
  // TRANSPARENCY: '/transparency',
  TRANSPARENCY: '/transparencia',
  CABINET: '/cabinet',
  // PRESS_ROOM: '/press-room',
  PRESS_ROOM: '/sala-de-prensa',
  PROCEDURES: '/procedures',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  DASHBOARD_PROCEDURES: '/procedures',
  PROCEDURES_AND_SERVICES: '/proceduresAndServices',
  // PARTICIPATE: '/participate',
  PARTICIPATE: '/participa',
  HOME: '/',
  EVENTS: '/events',
  PQRSDF: '/dashboard/pqrsdf',
  TAXES: '/dashboard/taxes',
  TAXES_LIST: '/taxes',
  PQRSDF_OPTIONS: '/pqrsdf',
  // INSTITUTIONAL_PROGRAMS: '/institutional-programs',
  INSTITUTIONAL_PROGRAMS: '/programas-institucionales',
};

export const ROUTES_INTERNAL: { [key in SubPages]: string } = {
  Home: ROUTES_CLIENT.HOME,
  Regulation: ROUTES_CLIENT.REGULATIONS,
  Transparency: ROUTES_CLIENT.TRANSPARENCY,
  PressRoom: ROUTES_CLIENT.PRESS_ROOM,
  Procedures: ROUTES_CLIENT.PROCEDURES,
  Newsletter: '/',
  Events: ROUTES_CLIENT.EVENTS,
  Sns: '/',
  Cabinet: ROUTES_CLIENT.CABINET,
  Participate: ROUTES_CLIENT.PARTICIPATE,
  InstitutionalPrograms: ROUTES_CLIENT.INSTITUTIONAL_PROGRAMS,
  Pqrsdf: ROUTES_CLIENT.PQRSDF_OPTIONS,
};

// export const SECTION_LIST = [
//   { label: 'General', value: DynamicPageSection.General },
//   { label: 'Participa', value: DynamicPageSection.Participate },
// ];

export const HTML_ELEMENTS_ACCESSIBILITY =
  'span:not(.glyphicon), p, a, h1, h2, h3, h4, h5, input, div,strong:not(.fa), font';

export const INITIAL_CONFIG_ACCESSIBILITY_BAR = {
  storytellerEnabled: false,
  fontSize: 0,
  isCursorBig: false,
  isDislexic: false,
  isHightlightLink: false,
  langTeller: 'es-ES',
  languaje: 'es',
};

export const TOKEN_CLIENT = 'token';
export const TOKEN_ADMIN = 'token_admin';

export const STATE_PROCESS_INSTANCE_LIST = [
  { value: 'Active', text: 'En Proceso' },
  { value: 'Suspended', text: 'Rechazado' },
  { value: 'Completed', text: 'Respondido' },
  { value: 'ExternallyTerminated', text: 'Terminación Externa' },
  { value: 'InternallyTerminated', text: 'Terminación Interna' },
];

export const FILTER_ORDER_BY_PROCESS_INSTANCE_LIST = [
  { key: 'startTime_ASC', text: 'Más reciente', value: { startTime: 'DESC' } },
  { key: 'startTime_DESC', text: 'Menos reciente', value: { startTime: 'ASC' } },
  { key: 'requestNumber_DESC', text: 'Radicado (mayor a menor)', value: { requestNumber: 'DESC' } },
  { key: 'requestNumber_ASC', text: 'Radicado (menor a mayor)', value: { requestNumber: 'ASC' } },
];

export const TYPE_PROCEDURE_SERVICES_LIST = [
  { value: ProcedureTypes.Procedure, text: 'Trámite' },
  { value: ProcedureTypes.Service, text: 'Servicio' },
  { value: ProcedureTypes.InformationOfInterest, text: 'Información de interés' },
];

export const IMPUESTO_PREDIAL_TYPE = 'Impuesto Predial';

export const CAMUNDA_FORM_JSON = {
  components: [
    {
      text: 'Hago mi solicitud',
      label: 'Text view',
      type: 'text',
      layout: { row: 'Row_13790r0', columns: null },
      properties: {
        type: 'tab',
        label: 'Hago mi solicitud',
        tabOrder: '2',
        tabGroup: 'tab-1',
        order: '2',
        tabId: 'tab_2-1',
      },
      id: 'Field_1m6s8zp',
    },
    {
      text: 'Inicio',
      label: 'Text view',
      type: 'text',
      layout: { row: 'Row_13790r0', columns: null },
      properties: {
        type: 'tab',
        label: 'Inicio',
        tabOrder: '1',
        tabGroup: 'tab-1',
        order: '2',
        tabId: 'tab_1-1',
      },
      id: 'Field_1rfhxv0',
    },
    {
      text: 'Procesar mi solicitud',
      label: 'Text view',
      type: 'text',
      layout: { row: 'Row_13790r0', columns: null },
      id: 'Field_1rtgbm0',
      properties: {
        type: 'tab',
        label: 'Procesan mi solicitud',
        tabOrder: '3',
        tabGroup: 'tab-1',
        order: '2',
        tabId: 'tab_3-1',
      },
    },
    {
      label: 'Nombre',
      type: 'textfield',
      layout: { row: 'Row_1yzrj2s', columns: 4 },
      id: 'Field_08u4oey',
      key: 'textfield_mvnii',
      validate: { required: true },
      properties: { tabGroup: 'tab-1', tabId: 'tab_2-1' },
    },
    {
      label: 'Primer Apellido',
      type: 'textfield',
      layout: { row: 'Row_1yzrj2s', columns: 4 },
      id: 'Field_1o4zizy',
      key: 'textfield_7h25vb',
      properties: { tabGroup: 'tab-1', tabId: 'tab_2-1' },
    },
    {
      label: 'Segundo Apellido',
      type: 'textfield',
      layout: { row: 'Row_1yzrj2s', columns: 4 },
      id: 'Field_1svyx7e',
      key: 'textfield_flpkn',
      properties: { tabGroup: 'tab-1', tabId: 'tab_2-1' },
    },
    {
      label: 'Number',
      type: 'number',
      layout: { row: 'Row_0bzjaug', columns: null },
      id: 'Field_07j8nl9',
      key: 'number_r9p7jc',
      properties: { order: '1' },
    },
    {
      values: [
        { label: 'Primera opcion', value: '1' },
        { label: 'Segunda opcion', value: '2' },
      ],
      label: 'Selecciona una opcion',
      type: 'select',
      layout: { row: 'Row_0jsc6ng', columns: null },
      id: 'Field_0iqoqj5',
      key: 'select_fffa5',
      properties: { order: '99' },
    },
    {
      label: 'Nuevo campo de texto',
      type: 'textfield',
      layout: { row: 'Row_193fkq7', columns: null },
      id: 'Field_0vvwmll',
      key: 'textfield_afbytb',
      properties: { tabGroup: 'tab-1', tabId: 'tab_1-1' },
    },
    {
      label: 'Documento identidad',
      type: 'textfield',
      layout: { row: 'Row_1fdr6je', columns: null },
      id: 'Field_18f51c8',
      key: 'textfield_ljmssb',
      properties: {
        inputType: 'file',
        order: '4',
        tabGroup: 'tab-1',
        fileTypes: '["pdf"]',
        tabId: 'tab_2-1',
      },
      validate: { required: true },
    },
    {
      label: 'Registro civil',
      type: 'textfield',
      layout: { row: 'Row_1v3vvzb', columns: null },
      id: 'Field_065twph',
      key: 'textfield_upz4tc',
      properties: { inputType: 'file', fileTypes: '["png"]', order: '123' },
    },
    {
      values: [{ label: 'Value', value: 'value' }],
      label: 'Departamento',
      type: 'select',
      layout: { row: 'Row_0e19dth', columns: 8 },
      id: 'Field_0je1kp9',
      key: 'department',
      properties: {
        urlEndpoint: 'https://nodejs.softwaretributario.com:8001/external/departments',
        keyPropEndpointData: 'Departamentos',
        httpMethod: 'post',
      },
    },
    {
      values: [{ label: 'Value', value: 'value' }],
      label: 'Municipio',
      type: 'select',
      layout: { row: 'Row_0e19dth', columns: 8 },
      id: 'Field_0dhl8ya',
      key: 'municipality',
      properties: {
        params_1: 'departmentId',
        urlEndpoint: 'https://nodejs.softwaretributario.com:8001/external/municipalities',
        httpMethod: 'post',
        dependentField_1: 'department',
        keyPropEndpointData: 'Municipios',
      },
    },
  ],
  type: 'default',
  id: 'Form_01a7w6d',
  exporter: { name: 'Camunda Modeler', version: '5.23.0' },
  executionPlatform: 'Camunda Platform',
  executionPlatformVersion: '7.21.0',
  schemaVersion: 16,
};

export const CAMUNDA_JSON_RESIDENCIA = {
  components: [
    {
      text: '# Información básica del solicitante',
      label: 'Text view',
      type: 'text',
      layout: { row: 'Row_0eyykuf', columns: 16 },
      id: 'Field_1dsvk9m',
    },
    {
      values: [
        { label: 'Cedula de ciudadania', value: 'C.C' },
        { label: 'Tarjeta de identidad', value: 'T.I' },
        { label: 'Cedula de extranjeria', value: 'C.E' },
        { label: 'NIT', value: 'nit' },
        { label: 'Carnet diplomatico', value: 'C.D' },
        { label: 'Pasaporte', value: 'P.A' },
        { label: 'Permiso especial de permanencia', value: 'P.E.P' },
        { label: 'Permiso de protección temporal', value: 'P.P.T' },
        { label: 'Salvoconducto', value: 'S.C' },
      ],
      label: 'Tipo de documento',
      type: 'select',
      layout: { row: 'Row_1kpdhsl', columns: 6 },
      id: 'Field_16qy05c',
      key: 'fieldDocumentType',
      validate: { required: true },
    },
    {
      label: 'No. de documento',
      type: 'number',
      layout: { row: 'Row_1kpdhsl', columns: 6 },
      id: 'Field_1w8m84k',
      key: 'fieldDocumentNumber',
      validate: { required: true },
    },
    {
      label: 'Lugar de expedición',
      type: 'textfield',
      layout: { row: 'Row_0j9j8il', columns: 8 },
      id: 'Field_1nmnoin',
      key: 'fieldExpeditionPlace',
      validate: { required: true },
    },
    {
      subtype: 'date',
      dateLabel: 'Fecha de expedición cédula',
      label: 'Date time',
      type: 'datetime',
      layout: { row: 'Row_0j9j8il', columns: 8 },
      id: 'Field_0h4lj5o',
      key: 'fieldDocumentDateIssue',
      validate: { required: true },
    },
    {
      label: 'Primer nombre',
      type: 'textfield',
      layout: { row: 'Row_0ujilpx', columns: 8 },
      id: 'Field_0fdaiew',
      key: 'fieldFirstName',
      validate: { required: true },
    },
    {
      label: 'Segundo nombre',
      type: 'textfield',
      layout: { row: 'Row_0ujilpx', columns: 8 },
      id: 'Field_1xfkw7n',
      key: 'fieldMiddleName',
      validate: { required: false },
    },
    {
      label: 'Primer apellido',
      type: 'textfield',
      layout: { row: 'Row_0pn27no', columns: 8 },
      id: 'Field_06lef23',
      key: 'fieldLastName',
      validate: { required: true },
    },
    {
      label: 'Segundo apellido',
      type: 'textfield',
      layout: { row: 'Row_0pn27no', columns: 8 },
      id: 'Field_0w079hu',
      key: 'fieldSecondSurname',
    },
    {
      subtype: 'date',
      dateLabel: 'Fecha de nacimiento',
      label: 'Date time',
      type: 'datetime',
      layout: { row: 'Row_1o70l4j', columns: 16 },
      id: 'Field_1frco19',
      key: 'fieldDateOfBirth',
      validate: { required: true },
    },
    {
      values: [{ label: 'Meta', value: 'meta' }],
      label: 'Departamento',
      type: 'select',
      layout: { row: 'Row_1t2238c', columns: 8 },
      id: 'Field_0fq2490',
      key: 'fieldDepartment',
      validate: { required: true },
    },
    {
      values: [{ label: 'Acacías', value: 'acacias' }],
      label: 'Municipio',
      type: 'select',
      layout: { row: 'Row_1t2238c', columns: 8 },
      id: 'Field_19nijmu',
      key: 'fieldCity',
      validate: { required: true },
    },
    {
      text: '# Información personal del solicitante',
      label: 'Text view',
      type: 'text',
      layout: { row: 'Row_1h0p13l', columns: 16 },
      id: 'Field_0oiyizl',
    },
    {
      values: [
        { label: 'Femenino', value: 'femenino' },
        { label: 'Masculino', value: 'masculino' },
        { label: 'Prefiero no decir', value: 'prefieroNoDecir' },
      ],
      label: 'Genero',
      type: 'select',
      layout: { row: 'Row_1h10bgc', columns: 16 },
      id: 'Field_1qfowhb',
      key: 'fieldGender',
      validate: { required: true },
    },
    {
      label: 'Correo electrónico',
      type: 'textfield',
      layout: { row: 'Row_0o0we49', columns: 8 },
      id: 'Field_0vgfqns',
      key: 'fieldEmail',
      validate: { required: true },
    },
    {
      label: 'Número de celular',
      type: 'number',
      layout: { row: 'Row_0o0we49', columns: 8 },
      id: 'Field_1gyd6gg',
      key: 'fieldPhone',
      validate: { required: true },
    },
    {
      values: [
        { label: 'Educación Pre-escolar', value: 'preescolar' },
        { label: 'Educación Básica ( Primaria / Bachiller )', value: 'basica' },
        { label: 'Educación Técnica', value: 'tecnica' },
        { label: 'Educación Tecnológica', value: 'tecnologica' },
        { label: 'Universitaria Pregrado', value: 'unipregrado' },
        { label: 'Universitaria Posgrado', value: 'uniposgrado' },
        { label: 'Doctorado', value: 'doctorado' },
      ],
      label: 'Tipo de educación',
      type: 'select',
      layout: { row: 'Row_0r64q7k', columns: 8 },
      id: 'Field_0hz3r02',
      key: 'fieldTypeOfEducation',
      validate: { required: true },
    },
    {
      values: [
        { label: 'Médico General', value: 'Medico General' },
        { label: 'Enfermero(a)', value: 'Enfermero(a)' },
        { label: 'Odontólogo(a)', value: 'Odontologo(a)' },
        { label: 'Profesor(a) de Educación Primaria', value: 'Profesor(a) de Educación Primaria' },
        {
          label: 'Profesor(a) de Educación Secundaria',
          value: 'Profesor(a) de Educación Secundaria',
        },
        { label: 'Profesor(a) Universitario(a)', value: 'Profesor(a) Universitario(a)' },
        { label: 'Ingeniero(a) Civil', value: 'Ingeniero(a) Civil' },
        { label: 'Ingeniero(a) de Sistemas', value: 'Ingeniero(a) de Sistemas' },
        { label: 'Ingeniero(a) Electrónico', value: 'Ingeniero(a) Electrónico' },
        { label: 'Abogado(a)', value: 'Abogado(a)' },
        { label: 'Juez', value: 'Juez' },
        { label: 'Notario(a)', value: 'Notario(a)' },
        { label: 'Fiscal', value: 'Fiscal' },
        { label: 'Secretario(a) Jurídico', value: 'Secretario(a) Jurídico' },
        { label: 'Asistente Legal', value: 'Asistente Legal' },
      ],
      label: 'Profesión, Oficio, Ocupación',
      type: 'select',
      layout: { row: 'Row_0r64q7k', columns: 8 },
      id: 'Field_0j34xha',
      key: 'fieldOccupation',
      validate: { required: true },
    },
    {
      text: '# Información de Residencia',
      label: 'Text view',
      type: 'text',
      layout: { row: 'Row_021f7yk', columns: 16 },
      id: 'Field_1qvuccc',
    },
    {
      values: [
        { label: 'MONTEBELLO', value: 'MONTEBELLO' },
        { label: 'PORTACHUELO', value: 'PORTACHUELO' },
        { label: 'LA PRIMAVERA', value: 'LA PRIMAVERA' },
        { label: 'SANTA ROSA', value: 'SANTA ROSA' },
        { label: 'LOMA DE TIGRE', value: 'LOMA DE TIGRE' },
        { label: 'EL TRIUNFO', value: 'EL TRIUNFO' },
        { label: 'LA ESMERALDA', value: 'LA ESMERALDA' },
        { label: 'LA LOMA', value: 'LA LOMA' },
        { label: 'QUEBRADITAS', value: 'QUEBRADITAS' },
        { label: 'SAN NICOLAS', value: 'SAN NICOLAS' },
        { label: 'DINAMARCA', value: 'DINAMARCA' },
        { label: 'EL CENTRO', value: 'EL CENTRO' },
        { label: 'MONTELIBANO', value: 'MONTELIBANO' },
        { label: 'LAS MARGARITAS', value: 'LAS MARGARITAS' },
        { label: 'LA UNIÓN', value: 'LA UNIÓN' },
      ],
      label: 'Barrio',
      type: 'select',
      layout: { row: 'Row_0jn3dv1', columns: 8 },
      id: 'Field_157fj7x',
      key: 'fieldDistrict',
      validate: { required: true },
    },
    {
      values: [{ label: 'Rural', value: 'Rural' }],
      label: 'Sector / Zona',
      type: 'select',
      layout: { row: 'Row_0jn3dv1', columns: 8 },
      id: 'Field_1fbfwgi',
      key: 'fieldZone',
      validate: { required: true },
    },
    {
      values: [{ label: 'Value', value: 'value' }],
      label: 'UP',
      type: 'select',
      layout: { row: 'Row_0phpdny', columns: 8 },
      id: 'Field_12gueot',
      key: 'fieldUP',
      validate: { required: true },
    },
    {
      label: 'Dirección',
      type: 'textfield',
      layout: { row: 'Row_0phpdny', columns: 8 },
      id: 'Field_1sshura',
      key: 'fieldAddress',
      validate: { required: true },
    },
  ],
  type: 'default',
  id: 'Form_0ofhxfa',
  exporter: { name: 'Camunda Modeler', version: '5.23.0' },
  executionPlatform: 'Camunda Platform',
  executionPlatformVersion: '7.21.0',
  schemaVersion: 16,
};

export const CAMUNDA_FORM_JSON_2 = {
  components: [
    {
      id: 'Field_1e8axo0',
      label: 'Filtro de trámite',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_05cd2i6', __typename: 'CamundaFormLayout' },
      key: 'fieldProcedure',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: null,
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1pttvyd',
      label: 'Tipo de trámite',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_05cd2i6', __typename: 'CamundaFormLayout' },
      key: 'fieldProcedureType',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: null,
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0tg240u',
      label: 'IvrCod',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_0uxvvd4', __typename: 'CamundaFormLayout' },
      key: 'fieldIvrCod',
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'IvrCod' },
      defaultValue: '46',
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_09z4kmd',
      label: 'ImpCod',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_0uxvvd4', __typename: 'CamundaFormLayout' },
      key: 'fieldImpCod',
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'ImpCod' },
      defaultValue: 'RENTA',
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1krat24',
      label: 'Asunto de la solicitud',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '12', row: 'Row_0w65xi2', __typename: 'CamundaFormLayout' },
      key: 'fieldSubject',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: 'Alquiler de escenarios deportivos',
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_03icywx',
      label: 'Text view',
      dateLabel: null,
      type: 'text',
      layout: { columns: '12', row: 'Row_0s97veh', __typename: 'CamundaFormLayout' },
      key: null,
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { type: 'group', groupId: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: '# INFORMACIÓN BÁSICA DE LA SOLICITUD',
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0fo83e9',
      label: 'Tipo de documento de identidad',
      dateLabel: null,
      type: 'select',
      layout: { columns: '6', row: 'Row_04xhnqk', __typename: 'CamundaFormLayout' },
      key: 'fieldDocType',
      values: [
        { label: 'Cedula de ciudadania', value: 'c.c', __typename: 'CamundaFormOptions' },
        { label: 'Tarjeta de identidad', value: 't.i', __typename: 'CamundaFormOptions' },
        { label: 'Cedula de extranjeria', value: 'c.e', __typename: 'CamundaFormOptions' },
        { label: 'NIT', value: 'nit', __typename: 'CamundaFormOptions' },
        { label: 'Carnet diplomatico', value: 'c.d', __typename: 'CamundaFormOptions' },
        { label: 'Pasaporte', value: 'p.a', __typename: 'CamundaFormOptions' },
        {
          label: 'Permiso especial de permanencia',
          value: 'p.e.p',
          __typename: 'CamundaFormOptions',
        },
        {
          label: 'Permiso de protección temporal',
          value: 'p.p.t',
          __typename: 'CamundaFormOptions',
        },
        { label: 'Salvoconducto', value: 's.c', __typename: 'CamundaFormOptions' },
      ],
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntTipId', group: 'basic_info' },
      defaultValue: 'CC',
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0ag742m',
      label: 'Número de documento de identidad',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_04xhnqk', __typename: 'CamundaFormLayout' },
      key: 'fieldIdentification',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntCod', group: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1d7nwv5',
      label: 'Primer nombre',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_00epxch', __typename: 'CamundaFormLayout' },
      key: 'fieldFirstName',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntNom', group: 'basic_info' },
      defaultValue: null,
      conditional: { hide: '=cont_docType = "nit"' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1kwyp7b',
      label: 'Primer apellido',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_00epxch', __typename: 'CamundaFormLayout' },
      key: 'fieldLastName',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { group: 'basic_info' },
      defaultValue: null,
      conditional: { hide: '=cont_docType = "nit"' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0ix3zzi',
      label: 'Razón Social',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_128mq9i', __typename: 'CamundaFormLayout' },
      key: 'fieldRazSoc',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntRazSoc', group: 'basic_info' },
      defaultValue: null,
      conditional: { hide: '=cont_docType="c.c"' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0n36sy4',
      label: 'Identificación Id',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_128mq9i', __typename: 'CamundaFormLayout' },
      key: 'fieldIdentificationId',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntId', group: 'basic_info' },
      defaultValue: null,
      conditional: { hide: '=cont_docType="c.c"' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_13h1wru',
      label: 'Número de telefono',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_1y5dfwa', __typename: 'CamundaFormLayout' },
      key: 'fieldPhone',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntNotCel', group: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1a3xdd7',
      label: 'Correo electrónico',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_1y5dfwa', __typename: 'CamundaFormLayout' },
      key: 'fieldEmail',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: 'email',
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntNotEmail', group: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_15rpq95',
      label: 'Departamento',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_1hmsydi', __typename: 'CamundaFormLayout' },
      key: 'fieldDepartment',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntNotDptCod', group: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_106rt5g',
      label: 'Municipio',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '6', row: 'Row_1hmsydi', __typename: 'CamundaFormLayout' },
      key: 'fieldCity',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntNotMunCod', group: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1oo1ktp',
      label: 'Dirección de residencia',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '12', row: 'Row_1k0es7k', __typename: 'CamundaFormLayout' },
      key: 'fieldAddress',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CntDir', group: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0s88kbw',
      label: 'Detalle de la solicitud',
      dateLabel: null,
      type: 'textarea',
      layout: { columns: '12', row: 'Row_15bd6y0', __typename: 'CamundaFormLayout' },
      key: 'fieldDescription',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { group: 'basic_info' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_08e5gd9',
      label: 'Text view',
      dateLabel: null,
      type: 'text',
      layout: { columns: '12', row: 'Row_1ovllyj', __typename: 'CamundaFormLayout' },
      key: null,
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { type: 'group', groupId: 'attachment' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: '# DOCUMENTACIÓN',
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0opajk2',
      label: 'Documentos necesarios',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '12', row: 'Row_1si2lrl', __typename: 'CamundaFormLayout' },
      key: 'fieldDocumentation',
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { inputType: 'file', fileTypes: '["pdf"]', group: 'attachment' },
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_030trbv',
      label: 'Acepto los términos y condiciones de uso de datos personales',
      dateLabel: null,
      type: 'checkbox',
      layout: { columns: '12', row: 'Row_0jxfg45', __typename: 'CamundaFormLayout' },
      key: 'fieldAcceptFirst',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1aul3lu',
      label:
        'Acepto las condiciones establecidas en la política de tratamiento de información de la Alcaldía',
      dateLabel: null,
      type: 'checkbox',
      layout: { columns: '12', row: 'Row_0dd4yxs', __typename: 'CamundaFormLayout' },
      key: 'fieldAcceptSecond',
      values: null,
      validate: {
        required: true,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0voov5g',
      label: 'Radicar',
      dateLabel: null,
      type: 'button',
      layout: { columns: '12', row: 'Row_18skm9v', __typename: 'CamundaFormLayout' },
      key: null,
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: null,
      conditional: null,
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0y6ejg5',
      label: 'Conceptos01',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '4', row: 'Row_1k6nezk', __typename: 'CamundaFormLayout' },
      key: 'fieldConcept01',
      values: null,
      validate: {
        required: false,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: '',
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1mhkkl3',
      label: 'Conceptos02',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '4', row: 'Row_1k6nezk', __typename: 'CamundaFormLayout' },
      key: 'fieldConcept02',
      values: null,
      validate: {
        required: false,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: null,
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_1jo6uro',
      label: 'Conceptos03',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '4', row: 'Row_1k6nezk', __typename: 'CamundaFormLayout' },
      key: 'fieldConcept03',
      values: null,
      validate: {
        required: false,
        min: null,
        max: null,
        validationType: null,
        minLength: null,
        maxLength: null,
        __typename: 'CamundaFormValidate',
      },
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: null,
      defaultValue: null,
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_05x5oai',
      label: 'Array Conceptos #1',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '4', row: 'Row_06z6gyp', __typename: 'CamundaFormLayout' },
      key: 'fieldArrayConcept01',
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'CptCod' },
      defaultValue: null,
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_10nbe3v',
      label: 'Array Conceptos #2',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '4', row: 'Row_06z6gyp', __typename: 'CamundaFormLayout' },
      key: 'fieldArrayConcept02',
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'LiviCnt' },
      defaultValue: null,
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
    {
      id: 'Field_0tovce2',
      label: 'Array conceptos #3',
      dateLabel: null,
      type: 'textfield',
      layout: { columns: '4', row: 'Row_06z6gyp', __typename: 'CamundaFormLayout' },
      key: 'fieldArrayConcept03',
      values: null,
      validate: null,
      timeLabel: null,
      timeSerializingFormat: null,
      timeInterval: null,
      use24h: null,
      fieldResponse: null,
      properties: { homologationField: 'LiviBseVlr' },
      defaultValue: null,
      conditional: { hide: '=true' },
      description: null,
      text: null,
      customProperties: null,
      __typename: 'CamundaField',
    },
  ],
  type: 'default',
  id: 'Form_0qd6m9x',
  exporter: { name: 'Camunda Modeler', version: '5.18.0' },
  executionPlatform: 'Camunda Platform',
  executionPlatformVersion: '7.20.0',
  schemaVersion: 13,
};
